import { render } from "./customers-modal.vue?vue&type=template&id=3583f90d&scoped=true"
import script from "./customers-modal.vue?vue&type=script&lang=js"
export * from "./customers-modal.vue?vue&type=script&lang=js"

import "./customers-modal.vue?vue&type=style&index=0&id=3583f90d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3583f90d"]])

export default __exports__